"use strict";

var Marionette = require("marionette");
var Backbone = require("backbone");
var App = require("app");
var _ = require("lodash");
var Constants_rhm;

var rhm_reg_types = {
  NONE: 0,
  STATE1: 1, /* STANDBY || VERZOEK || VRAAG || NA_CIRCULATIE || UIT */
  STATE2: 2, /* UIT || AAN */
  STATE3: 3, /* VERWARMEN || KOELEN */
  STATE4: 4, /* GEEN VRAAG || VRAAG */
  STATE5: 5, /* NIET VERBONDEN || VERBONDEN */
  STATE6: 6, /* UIT || ANTI VRIES || ECO || COMFORT || DYNAMISCH */
  STATE7: 7, /* UITGESCHAKELD || INGESCHAKELD */
  STATE8: 8, /* NEE || JA */
  STATE9: 9, /* AAN || UIT */
  STATE10: 10, /* OFFLINE || ONLINE */
  STATE11: 11, /* LIMITED || METER ERROR || COMMS ERROR || METER MISSING || RESERVED... */
  STATE12: 12,
  STATE13: 13, /* OPEN || GESLOTEN */

  MEDIA: 80,
  TEMP: 100, /* celcius */
  PRES: 101, /* bar */
  TIME_S: 102,
  TIME_M: 103,
  TIME_H: 104,
  STEPS: 105,
  FLOW_L_M: 106, /* L/M */
  FLOW_L_H: 107, /* L/H */
  PERC: 108,  /* % */
  POWER: 109, /* kW  / 100 :( */
  ENERGY: 110, /* GJ */
  VOLUME: 111, /* L */
  CURRENT: 112, /* mA */
  DATE:    113,
  ENERGY_kWh: 114, /* kWH */
  POWER_NORMAL: 115, /* kW but then / 1000 */
  HEX:  125,
  TIME_D: 126,
  VOLUME_M3: 127,
  FLOW_DL_M: 128,
  FLOW_M3_H: 129,
};

var rhm_reg_perm_types = {
  NONE:0,
  READ:1,
  WRITE:2,
  READ_WRITE: 3
};

var rhm_reg_permissions = [
  [98, 99, rhm_reg_perm_types.WRITE],
  [300, 303, rhm_reg_perm_types.READ_WRITE],
  [400, 403, rhm_reg_perm_types.READ_WRITE],
  [500, 515, rhm_reg_perm_types.READ_WRITE],
  [600, 611, rhm_reg_perm_types.READ_WRITE],
  [700, 706, rhm_reg_perm_types.READ_WRITE],
  [1400, 1402, rhm_reg_perm_types.READ_WRITE],
  [1404, 1406, rhm_reg_perm_types.READ_WRITE],
  [1500, 1502, rhm_reg_perm_types.READ_WRITE],
  [1503, 1507, rhm_reg_perm_types.READ_WRITE],
  [1700, 1700, rhm_reg_perm_types.READ_WRITE],
  [1703, 1703, rhm_reg_perm_types.READ_WRITE],
  [1707, 1707, rhm_reg_perm_types.READ_WRITE],
  [1800, 1801, rhm_reg_perm_types.READ_WRITE],
  [1803, 1812, rhm_reg_perm_types.READ_WRITE],
  [1814, 1815, rhm_reg_perm_types.READ_WRITE],
  [1851, 1853, rhm_reg_perm_types.READ_WRITE],
  [1855, 1856, rhm_reg_perm_types.READ_WRITE],
  [1858, 1858, rhm_reg_perm_types.READ_WRITE],
  [1863, 1866, rhm_reg_perm_types.READ_WRITE],
]

var rhm_reg_states = [
  {
    type:rhm_reg_types.STATE1,
    states:[
      { label: "Stand-by",      id: 0 },
      { label: "Verzoek",       id: 1 },
      { label: "Vraag",         id: 2 },
      { label: "Na-circulatie", id: 3 },
      { label: "Uit",           id: 4 }
    ]
  },
  {
    type:rhm_reg_types.STATE2,
    states:[
      { label: "Uit", id: 0 }, { label: "Aan", id: 1 }
    ]
  },
  {
    type:rhm_reg_types.STATE3,
    states:[
      { label: "Verwarmen", id: 0 },
      { label: "Koelen", id: 1 },
    ]
  },
  {
    type:rhm_reg_types.STATE4,
    states:[
        { label: "Unknown", id: 0}, { label: "Geen vraag", id: 1 }, { label: "Vraag", id: 2 }
    ]
  },
  {
    type:rhm_reg_types.STATE5,
    states:[
      { label: "Niet verbonden", id: 0 }, { label: "Verbonden", id: 1 }
    ]
  },
  {
    type:rhm_reg_types.STATE6,
    states:[
      { label: "Uit",         id: 0 },
      { label: "Anti vries",  id: 1 },
      { label: "Eco",         id: 2 },
      { label: "Comfort",     id: 3 },
      { label: "Dynamisch",   id: 4 }
    ]
  },
  {
    type:rhm_reg_types.STATE7,
    states:[
      { label: "Uitgeschakeld", id: 0 }, { label: "Ingeschakeld", id: 1 }
    ]
  },
  {
    type:rhm_reg_types.STATE8,
    states:[
      { label: "Nee", id: 0 }, { label: "Ja", id: 1 },

    ]
  },
  {
    type:rhm_reg_types.STATE9,
    states:[
      { label: "Aan", id: 0}, { label: "Uit", id: 1},

    ]
  },
  {
    type:rhm_reg_types.STATE10,
    states:[
      { label: "Offline", id: 0}, { label: "Online",  id: 1},
    ]
  },
  {
    type:rhm_reg_types.STATE11,
    states:[
      { label: "Unknown",       id: 0},
      { label: "Limited",       id: 1},
      { label: "Meter error",   id: 2},
      { label: "Unknown",       id: 3},
      { label: "Comms error",   id: 4},
      { label: "Unknown",       id: 5},
      { label: "Unknown",       id: 6},
      { label: "Unknown",       id: 7},
      { label: "Meter missing", id: 8},
    ]
  },
  {
    type:rhm_reg_types.STATE12,
    states:[
        { label: "Unknown",              id: 0   },
        { label: "DHW",                  id: 1   },
        { label: "DHW + Booster pomp",   id: 2   },
        { label: "DHW + CH-zone",        id: 3   },
        { label: "DHW + Ch Mix",         id: 4   },
        { label: "DHW + CH Hex",         id: 5   },
        { label: "DHW + CH Hex Frese",   id: 6   },
        { label: "DHW + CH Hex Koeling", id: 7   },
        { label: "Koeling",              id: 8   },
        { label: "DCH Mix",              id: 9   },
        { label: "Hoval",                id: 10  },
        { label: "TE Booster",           id: 11  },
      ]
  },
  {
    type:rhm_reg_perm_types.STATE13,
    states:[
      { label: "Open", id: 1 },
      { label: "Gesloten", id: 2 },
    ]
  },
  {
    type:rhm_reg_types.MEDIA,
    states:[
        { label: "Other",               id: 0  },
        { label: "Oil",                 id: 1  },
        { label: "Electricity",         id: 2  },
        { label: "Gas",                 id: 3  },
        { label: "Heat Outlet",         id: 4  },
        { label: "Steam",               id: 5  },
        { label: "Hot Water",           id: 6  },
        { label: "Water",               id: 7  },
        { label: "Heat Cost Allocator", id: 8  },
        { label: "Compressed Air",      id: 9  },
        { label: "Cool Outlet",         id: 10 },
        { label: "Cool Inlet",          id: 11 },
        { label: "Heat Inlet",          id: 12 },
        { label: "Cooling / Heating",   id: 13 },
        { label: "Bus / System",        id: 14 },
        { label: "Unknown",             id: 15 },
        { label: "Cold Water",          id: 16 },
        { label: "Dual Water",          id: 17 },
      ]
  }
]

var Constants_rhm = {
  types: rhm_reg_types,
  permission_types: rhm_reg_perm_types,
  permissions: rhm_reg_permissions,
  states: rhm_reg_states,
  rhmRegister: [
    {
      regAddr: 96,
      type: rhm_reg_types.NONE,
      perm: 0,
      label: "Modbus Version"
    },
    {
      regAddr: 97,
      type: rhm_reg_types.NONE,
      perm: 0,
      label: "Modbus Device type"
    },
    {
      regAddr: 98,
      type: rhm_reg_types.NONE,
      perm: 0,
      label: "Unit selection"
    },
    {
      regAddr: 99,
      type: rhm_reg_types.NONE,
      perm: 0,
      label: "Control register"
    },

    { regAddr: 100, type: rhm_reg_types.STATE1,    perm: 0, label: "Verwarming" },
    { regAddr: 101, type: rhm_reg_types.STATE1,    perm: 0, label: "Warm tapwater" },
    { regAddr: 102, type: rhm_reg_types.STATE1,    perm: 0, label: "Warmhoud functie" },
    { regAddr: 103, type: rhm_reg_types.STATE1,    perm: 0, label: "Anti-legionella" },
    { regAddr: 104, type: rhm_reg_types.STATE1,    perm: 0, label: "Koeling" },
    { regAddr: 105, type: rhm_reg_types.NONE,      perm: 0, label: "Foutmelding" },
    { regAddr: 106, type: rhm_reg_types.HEX,       perm: 0, label: "Software versie" },
    { regAddr: 107, type: rhm_reg_types.STEPS,     perm: 0, label: "Positie tapwater afsluiter" },
    { regAddr: 108, type: rhm_reg_types.STEPS,     perm: 0, label: "Positie CV afsluiter" },
    { regAddr: 109, type: rhm_reg_types.STATE2,    perm: 0, label: "Pomp" },
    { regAddr: 110, type: rhm_reg_types.STATE3,    perm: 0, label: "Stand 6-weg kogelafsluiter" },
    { regAddr: 113, type: rhm_reg_types.STATE13,    perm: 0, label: "Ruimtethermostaat (contact)" },
    { regAddr: 114, type: rhm_reg_types.STATE5,    perm: 0, label: "OpenTherm communicatie" },
    { regAddr: 115, type: rhm_reg_types.STATE12,   perm: 0, label: "Toesteltype" },
    { regAddr: 200, type: rhm_reg_types.FLOW_DL_M, perm: 0, label: "Flow warmtapwater" },
    { regAddr: 201, type: rhm_reg_types.TEMP,      perm: 0, label: "T-warmtapwater" },
    { regAddr: 202, type: rhm_reg_types.TEMP,      perm: 0, label: "T-aanvoer primair" },
    { regAddr: 203, type: rhm_reg_types.TEMP,      perm: 0, label: "T-retour primair" },
    { regAddr: 204, type: rhm_reg_types.TEMP,      perm: 0, label: "Setpoint T-aanvoer secundair verwarming" },
    { regAddr: 205, type: rhm_reg_types.TEMP,      perm: 0, label: "T-aanvoer secundair" },
    { regAddr: 206, type: rhm_reg_types.TEMP,      perm: 0, label: "T-retour secundair" },
    { regAddr: 207, type: rhm_reg_types.TEMP,      perm: 0, label: "T-ruimte  meting (OT)" },
    { regAddr: 208, type: rhm_reg_types.TEMP,      perm: 0, label: "T-ruimte instelling (OT)" },
    { regAddr: 209, type: rhm_reg_types.TEMP,      perm: 0, label: "Outdoor temperature" },
    { regAddr: 210, type: rhm_reg_types.PRES,      perm: 0, label: "Waterdruk verwarming" },
    { regAddr: 300, type: rhm_reg_types.TEMP,      perm: 0, label: "T-warm tapwater" },
    { regAddr: 301, type: rhm_reg_types.STATE6,    perm: 0, label: "Warmhoud modus" },
    { regAddr: 302, type: rhm_reg_types.TEMP,      perm: 0, label: "Warmhoudtemperatuur (comfort)" },
    { regAddr: 400, type: rhm_reg_types.STATE2,    perm: 0, label: "Thermische desinfectie" },
    { regAddr: 401, type: rhm_reg_types.TEMP,      perm: 0, label: "Desinfectie temperatuur" },
    { regAddr: 402, type: rhm_reg_types.TIME_M,    perm: 0, label: "Desinfectie tijd" },
    { regAddr: 403, type: rhm_reg_types.TIME_H,    perm: 0, label: "Wachttijd na einde tapwater" },
    { regAddr: 500, type: rhm_reg_types.TEMP,      perm: 0, label: "T-aanvoer verwarming (setpoint)" },
    { regAddr: 501, type: rhm_reg_types.TEMP,      perm: 0, label: "CH min setpoint" },
    { regAddr: 502, type: rhm_reg_types.TEMP,      perm: 0, label: "Outdoor reset min" },
    { regAddr: 503, type: rhm_reg_types.TEMP,      perm: 0, label: "Outdoor reset max" },
    { regAddr: 504, type: rhm_reg_types.TEMP,      perm: 0, label: "Warm weather shut" },
    { regAddr: 505, type: rhm_reg_types.TEMP,      perm: 0, label: "Room temperature compensation" },
    { regAddr: 506, type: rhm_reg_types.TEMP,      perm: 0, label: "T-retourbegrenzing" },
    { regAddr: 507, type: rhm_reg_types.PERC,      perm: 0, label: "Retour compensatie factor" },
    { regAddr: 508, type: rhm_reg_types.TEMP,      perm: 0, label: "Delta primary ch setpoint" },
    { regAddr: 509, type: rhm_reg_types.TEMP,      perm: 0, label: "Start off-set t.o.v. primaire aanvoer" },
    { regAddr: 510, type: rhm_reg_types.TEMP,      perm: 0, label: "T-maximaal beveiliging" },
    { regAddr: 512, type: rhm_reg_types.PRES,      perm: 0, label: "Lage druk beveiliging" },
    { regAddr: 513, type: rhm_reg_types.PRES,      perm: 0, label: "Hoge druk beveiliging" },
    { regAddr: 514, type: rhm_reg_types.TEMP,      perm: 0, label: "CH setpoint" },
    { regAddr: 515, type: rhm_reg_types.STATE4,    perm: 0, label: "CH enable" },
    { regAddr: 600, type: rhm_reg_types.TEMP,      perm: 0, label: "T-aanvoer koeling (setpoint)" },
    { regAddr: 601, type: rhm_reg_types.TEMP,      perm: 0, label: "T-retourbegrenzing" },
    { regAddr: 602, type: rhm_reg_types.PERC,      perm: 0, label: "Retour compensatie factor" },
    { regAddr: 603, type: rhm_reg_types.TIME_M,    perm: 0, label: "Wachttijd verwarmen / koelen" },
    { regAddr: 604, type: rhm_reg_types.TIME_S,    perm: 0, label: "6-wegafsluiter, looptijd" },
    { regAddr: 605, type: rhm_reg_types.TEMP,      perm: 0, label: "T-maximaal beveiliging"  },
    { regAddr: 606, type: rhm_reg_types.TEMP,      perm: 0, label: "T-aanvoer koeling minimaal" },
    { regAddr: 607, type: rhm_reg_types.TEMP,      perm: 0, label: "Cool setpoint max" },
    { regAddr: 608, type: rhm_reg_types.STATE4,    perm: 0, label: "Condens protection" },
    { regAddr: 609, type: rhm_reg_types.TIME_M,    perm: 0, label: "Condens timer" },
    { regAddr: 610, type: rhm_reg_types.TEMP,      perm: 0, label: "Condens increased setpoint" },
    { regAddr: 611, type: rhm_reg_types.STATE4,    perm: 0, label: "Cool enable" },
    { regAddr: 700, type: rhm_reg_types.STATE2,    perm: 0, label: "Activeren handbediening" },
    { regAddr: 701, type: rhm_reg_types.STEPS,     perm: 0, label: "Tapwater afsluiter" },
    { regAddr: 702, type: rhm_reg_types.STEPS,     perm: 0, label: "CV afsluiter" },
    { regAddr: 703, type: rhm_reg_types.STATE2,    perm: 0, label: "Pomp" },
    { regAddr: 704, type: rhm_reg_types.STATE3,    perm: 0, label: "6-wegafsluiter verwarmen / koelen" },
    { regAddr: 706, type: rhm_reg_types.STATE5,    perm: 0, label: "Heat demand status output" },
    { regAddr: 709, type: rhm_reg_types.NONE,      perm: 0, label: "Handbediening time-out" },
    { regAddr: 800, type: rhm_reg_types.TIME_D,    perm: 0, label: "Totale systeem bedrijfstijd" },
    { regAddr: 801, type: rhm_reg_types.TIME_H,    perm: 0, label: "Totale CV bedrijfstijd" },
    { regAddr: 802, type: rhm_reg_types.TIME_H,    perm: 0, label: "Totale koeling bedrijfstijd" },
    { regAddr: 803, type: rhm_reg_types.TIME_H,    perm: 0, label: "Totale tapwater bedrijfstijd" },
    { regAddr: 804, type: rhm_reg_types.NONE,      perm: 0, label: "Aantal tappingen" },
    { regAddr: 805, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Tapwater volume" },
    { regAddr: 806, type: rhm_reg_types.NONE,      perm: 0, label: "Stroomonderbrekingen" },

    { regAddr: 820, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 1"},
    { regAddr: 821, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 2"},
    { regAddr: 822, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 3"},
    { regAddr: 823, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 4"},
    { regAddr: 824, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 5"},
    { regAddr: 825, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 6"},
    { regAddr: 826, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 7"},
    { regAddr: 827, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 8"},
    { regAddr: 828, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 9"},
    { regAddr: 829, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 10"},
    { regAddr: 830, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 11"},
    { regAddr: 831, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 12"},
    { regAddr: 832, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 13"},
    { regAddr: 833, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 14"},
    { regAddr: 834, type: rhm_reg_types.NONE,       perm: 0, label: "Lock error 15"},
    { regAddr: 860, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 1"},
    { regAddr: 861, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 2"},
    { regAddr: 862, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 3"},
    { regAddr: 863, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 4"},
    { regAddr: 864, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 5"},
    { regAddr: 865, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 6"},
    { regAddr: 866, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 7"},
    { regAddr: 867, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 8"},
    { regAddr: 868, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 9"},
    { regAddr: 869, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 10"},
    { regAddr: 870, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 11"},
    { regAddr: 871, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 12"},
    { regAddr: 872, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 13"},
    { regAddr: 873, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 14"},
    { regAddr: 874, type: rhm_reg_types.NONE,       perm: 0, label: "Block error 15"},
    { regAddr: 1000, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number", size: 2 },
    { regAddr: 1001, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number" },
    { regAddr: 1002, type: rhm_reg_types.NONE,      perm: 0, label: "Fabrikant" },
    { regAddr: 1006, type: rhm_reg_types.STATE10,   perm: 2, label: "Online status" },
    { regAddr: 1007, type: rhm_reg_types.FLOW_M3_H, perm: 0, label: "Flow energiemeter" },
    { regAddr: 1008, type: rhm_reg_types.POWER,     perm: 0, label: "Vermogen" },
    { regAddr: 1009, type: rhm_reg_types.TEMP,      perm: 0, label: "Aanvoer temperatuur" },
    { regAddr: 1010, type: rhm_reg_types.TEMP,      perm: 0, label: "Retour temperatuur	"  },
    { regAddr: 1011, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik", size: 2 },
    { regAddr: 1012, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik" },
    { regAddr: 1013, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume", size: 2 },
    { regAddr: 1014, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume" },
    { regAddr: 1050, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number", size: 2 },
    { regAddr: 1051, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number" },
    { regAddr: 1052, type: rhm_reg_types.NONE,      perm: 0, label: "Fabrikant" },
    { regAddr: 1056, type: rhm_reg_types.STATE10,   perm: 2, label: "Online status" },
    { regAddr: 1057, type: rhm_reg_types.FLOW_M3_H, perm: 0, label: "Flow energiemeter" },
    { regAddr: 1058, type: rhm_reg_types.POWER,     perm: 0, label: "Vermogen" },
    { regAddr: 1059, type: rhm_reg_types.TEMP,      perm: 0, label: "Aanvoer temperatuur" },
    { regAddr: 1060, type: rhm_reg_types.TEMP,      perm: 0, label: "Retour temperatuur	" },
    { regAddr: 1061, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik", size: 2 },
    { regAddr: 1062, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik" },
    { regAddr: 1063, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume", size: 2 },
    { regAddr: 1064, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume" },
    { regAddr: 1100, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number", size: 2 },
    { regAddr: 1101, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number" },
    { regAddr: 1102, type: rhm_reg_types.NONE,      perm: 0, label: "Fabrikant" },
    { regAddr: 1106, type: rhm_reg_types.STATE10,   perm: 2, label: "Online status" },
    { regAddr: 1107, type: rhm_reg_types.FLOW_M3_H, perm: 0, label: "Flow energiemeter" },
    { regAddr: 1108, type: rhm_reg_types.POWER,     perm: 0, label: "Vermogen" },
    { regAddr: 1109, type: rhm_reg_types.TEMP,      perm: 0, label: "Aanvoer temperatuur" },
    { regAddr: 1110, type: rhm_reg_types.TEMP,      perm: 0, label: "Retour temperatuur	" },
    { regAddr: 1111, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik", size: 2 },
    { regAddr: 1112, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik" },
    { regAddr: 1113, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume", size: 2 },
    { regAddr: 1114, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume" },
    { regAddr: 1150, type: rhm_reg_types.NONE,      perm: 0, label: "Serial / identification number", size: 2 },
    { regAddr: 1151, type: rhm_reg_types.HEX,       perm: 0, label: "Serial / identification number" },
    { regAddr: 1152, type: rhm_reg_types.HEX,       perm: 0, label: "Fabrikant" },
    { regAddr: 1156, type: rhm_reg_types.STATE10,   perm: 2, label: "Online status" },
    { regAddr: 1157, type: rhm_reg_types.FLOW_M3_H, perm: 0, label: "Flow energiemeter" },
    { regAddr: 1158, type: rhm_reg_types.POWER,     perm: 0, label: "Vermogen" },
    { regAddr: 1159, type: rhm_reg_types.TEMP,      perm: 0, label: "Aanvoer temperatuur" },
    { regAddr: 1160, type: rhm_reg_types.TEMP,      perm: 0, label: "Retour temperatuur	" },
    { regAddr: 1161, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik", size: 2 },
    { regAddr: 1162, type: rhm_reg_types.ENERGY,    perm: 0, label: "Totaal energieverbruik" },
    { regAddr: 1163, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume", size: 2 },
    { regAddr: 1164, type: rhm_reg_types.VOLUME_M3, perm: 0, label: "Totaal volume" },

    { regAddr: 1200, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number",  size: 2 },
    { regAddr: 1201, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number" },
    { regAddr: 1202, type: rhm_reg_types.NONE,          perm: 0, label: "Manufacturer" },
    { regAddr: 1203, type: rhm_reg_types.MEDIA,         perm: 0, label: "Medium" },
    { regAddr: 1204, type: rhm_reg_types.HEX,           perm: 0, label: "Status" },
    { regAddr: 1205, type: rhm_reg_types.FLOW_L_H,      perm: 0, label: "Flow" },
    { regAddr: 1206, type: rhm_reg_types.POWER_NORMAL,  perm: 0, label: "Power" },
    { regAddr: 1207, type: rhm_reg_types.TEMP,          perm: 0, label: "Supply Temperature" },
    { regAddr: 1208, type: rhm_reg_types.TEMP,          perm: 0, label: "Return Temperature" },
    { regAddr: 1209, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1", size: 2 },
    { regAddr: 1210, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1" },
    { regAddr: 1211, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume", size: 2  },
    { regAddr: 1212, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume" },
    { regAddr: 1213, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current", size: 2 },
    { regAddr: 1214, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current" },
    { regAddr: 1215, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1", size: 2 },
    { regAddr: 1216, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1" },
    { regAddr: 1217, type: rhm_reg_types.DATE,          perm: 0, label: "Fixed date" },
    { regAddr: 1218, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2",  size: 2 },
    { regAddr: 1219, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2" },

    { regAddr: 1220, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1221, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number" },
    { regAddr: 1222, type: rhm_reg_types.NONE,          perm: 0, label: "Manufacturer" },
    { regAddr: 1223, type: rhm_reg_types.MEDIA,         perm: 0, label: "Medium"},
    { regAddr: 1224, type: rhm_reg_types.HEX,           perm: 0, label: "Status" },
    { regAddr: 1225, type: rhm_reg_types.FLOW_L_H,      perm: 0, label: "Flow" },
    { regAddr: 1226, type: rhm_reg_types.POWER_NORMAL,  perm: 0, label: "Power" },
    { regAddr: 1227, type: rhm_reg_types.TEMP,          perm: 0, label: "Supply Temperature" },
    { regAddr: 1228, type: rhm_reg_types.TEMP,          perm: 0, label: "Return Temperature" },
    { regAddr: 1229, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1", size: 2 },
    { regAddr: 1230, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1" },
    { regAddr: 1231, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume", size: 2 },
    { regAddr: 1232, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume" },
    { regAddr: 1233, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current", size: 2 },
    { regAddr: 1234, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current" },
    { regAddr: 1235, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1", size: 2 },
    { regAddr: 1236, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1" },
    { regAddr: 1237, type: rhm_reg_types.DATE,          perm: 0, label: "Fixed date" },
    { regAddr: 1238, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2",  size: 2 },
    { regAddr: 1239, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2" },
    { regAddr: 1240, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1241, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1242, type: rhm_reg_types.NONE,          perm: 0, label: "Manufacturer" },
    { regAddr: 1243, type: rhm_reg_types.MEDIA,         perm: 0, label: "Medium" },
    { regAddr: 1244, type: rhm_reg_types.HEX,           perm: 0, label: "Status" },
    { regAddr: 1245, type: rhm_reg_types.FLOW_L_H,      perm: 0, label: "Flow" },
    { regAddr: 1246, type: rhm_reg_types.POWER_NORMAL,  perm: 0, label: "Power" },
    { regAddr: 1247, type: rhm_reg_types.TEMP,          perm: 0, label: "Supply Temperature" },
    { regAddr: 1248, type: rhm_reg_types.TEMP,          perm: 0, label: "Return Temperature" },
    { regAddr: 1249, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1", size: 2 },
    { regAddr: 1250, type: rhm_reg_types.ENERGY,        perm: 0, label: "Energy 1" },
    { regAddr: 1251, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume", size: 2 },
    { regAddr: 1252, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume" },
    { regAddr: 1253, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current",  size: 2 },
    { regAddr: 1254, type: rhm_reg_types.CURRENT,       perm: 0, label: "Current" },
    { regAddr: 1255, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1", size: 2 },
    { regAddr: 1256, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 1" },
    { regAddr: 1257, type: rhm_reg_types.DATE,          perm: 0, label: "Fixed date" },
    { regAddr: 1258, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2", size: 2 },
    { regAddr: 1259, type: rhm_reg_types.ENERGY,        perm: 0, label: "Fixed Energy 2" },
    { regAddr: 1260, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1261, type: rhm_reg_types.HEX,           perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1262, type: rhm_reg_types.NONE,          perm: 0, label: "Manufacturer" },
    { regAddr: 1263, type: rhm_reg_types.MEDIA,         perm: 0, label: "Medium" },
    { regAddr: 1264, type: rhm_reg_types.HEX,           perm: 0, label: "Status" },
    { regAddr: 1265, type: rhm_reg_types.FLOW_L_H,      perm: 0, label: "Flow" },
    { regAddr: 1266, type: rhm_reg_types.POWER_NORMAL,  perm: 0, label: "Power"},
    { regAddr: 1267, type: rhm_reg_types.TEMP,          perm: 0, label: "Supply Temperature" },
    { regAddr: 1268, type: rhm_reg_types.TEMP,          perm: 0, label: "Return Temperature" },
    { regAddr: 1269, type: rhm_reg_types.ENERGY, 	    	perm: 0, label: "Energy 1", size: 2 },
    { regAddr: 1270, type: rhm_reg_types.ENERGY,	     	perm: 0, label: "Energy 1" },
    { regAddr: 1271, type: rhm_reg_types.VOLUME,	     	perm: 0, label: "Volume", size: 2 },
    { regAddr: 1272, type: rhm_reg_types.VOLUME,	     	perm: 0, label: "Volume" },
    { regAddr: 1273, type: rhm_reg_types.CURRENT, 		  perm: 0, label: "Current", size: 2 },
    { regAddr: 1274, type: rhm_reg_types.CURRENT, 	   	perm: 0, label: "Current" },
    { regAddr: 1275, type: rhm_reg_types.ENERGY,  		  perm: 0, label: "Fixed Energy 1", size: 2 },
    { regAddr: 1276, type: rhm_reg_types.ENERGY,  		  perm: 0, label: "Fixed Energy 1" },
    { regAddr: 1277, type: rhm_reg_types.DATE,  			  perm: 0, label: "Fixed date"},
    { regAddr: 1278, type: rhm_reg_types.ENERGY, 		   	perm: 0, label: "Fixed Energy 2", size: 2 },
    { regAddr: 1279, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Fixed Energy 2" },
    { regAddr: 1280, type: rhm_reg_types.HEX,    			  perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1281, type: rhm_reg_types.HEX, 				  perm: 0, label: "Serial Number", size: 2 },
    { regAddr: 1282, type: rhm_reg_types.NONE,  			  perm: 0, label: "Manufacturer" },
    { regAddr: 1283, type: rhm_reg_types.MEDIA, 			  perm: 0, label: "Medium" },
    { regAddr: 1284, type: rhm_reg_types.HEX,  				  perm: 0, label: "Status" },
    { regAddr: 1285, type: rhm_reg_types.FLOW_L_H, 			perm: 0, label: "Flow" },
    { regAddr: 1286, type: rhm_reg_types.POWER_NORMAL, 	perm: 0, label: "Power" },
    { regAddr: 1287, type: rhm_reg_types.TEMP, 				  perm: 0, label: "Supply Temperature" },
    { regAddr: 1288, type: rhm_reg_types.TEMP, 				  perm: 0, label: "Return Temperature" },
    { regAddr: 1289, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Energy 1", size: 2 },
    { regAddr: 1290, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Energy 1" },
    { regAddr: 1291, type: rhm_reg_types.VOLUME, 			  perm: 0, label: "Volume", size: 2 },
    { regAddr: 1292, type: rhm_reg_types.VOLUME, 			  perm: 0, label: "Volume" },
    { regAddr: 1293, type: rhm_reg_types.CURRENT, 			perm: 0, label: "Current", size: 2 },
    { regAddr: 1294, type: rhm_reg_types.CURRENT, 			perm: 0, label: "Current" },
    { regAddr: 1295, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Fixed Energy 1", size: 2 },
    { regAddr: 1296, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Fixed Energy 1" },
    { regAddr: 1297, type: rhm_reg_types.DATE, 				  perm: 0, label: "Fixed date" },
    { regAddr: 1298, type: rhm_reg_types.ENERGY, 		   	perm: 0, label: "Fixed Energy 2", size: 2 },
    { regAddr: 1299, type: rhm_reg_types.ENERGY, 			  perm: 0, label: "Fixed Energy 2" },

    { regAddr: 1500, type: rhm_reg_types.STATE2,        perm: 2, label: "Begrenzing inschakelen" },
    { regAddr: 1501, type: rhm_reg_types.NONE,          perm: 0, label: "Serienummer begrenzing meter" },
    { regAddr: 1502, type: rhm_reg_types.NONE,          perm: 0, label: "Serienummer begrenzing meter" },
    { regAddr: 1503, type: rhm_reg_types.STATE11,       perm: 2, label: "Begrens status" },
    { regAddr: 1504, type: rhm_reg_types.NONE,          perm: 2, label: "Begrenzing configuratie DHW (h) en CH (l)" },
    { regAddr: 1505, type: rhm_reg_types.POWER,         perm: 0, label: "Begrens vermogen" },
    { regAddr: 1506, type: rhm_reg_types.FLOW_L_H,      perm: 0, label: "Begrens flow" },
    { regAddr: 1507, type: rhm_reg_types.TEMP,          perm: 0, label: "Begrens retour temperatuur (Alleen voor CH)" },
    { regAddr: 1800, type: rhm_reg_types.STATE7,        perm: 0, label: "TE-Booster inschakelen" },
    { regAddr: 1801, type: rhm_reg_types.STATE4,        perm: 0, label: "Elektisch element TE-Booster" },
    { regAddr: 1802, type: rhm_reg_types.STATE2,        perm: 0, label: "Boiler TE-booster" },
    { regAddr: 1804, type: rhm_reg_types.TEMP,          perm: 0, label: "TE-Booster boiler setpoint" },
    { regAddr: 1805, type: rhm_reg_types.NONE,          perm: 0, label: "Te-Booster boiler hysterese" },
    { regAddr: 1812, type: rhm_reg_types.TIME_H,        perm: 0, label: "Elektrisch element beveiliging" },
    { regAddr: 1813, type: rhm_reg_types.TIME_H,        perm: 0, label: "Elektrisch element beveiliging timer" },
    { regAddr: 1815, type: rhm_reg_types.VOLUME,        perm: 0, label: "Tapdrempel activatie elektrisch element" },
    { regAddr: 1816, type: rhm_reg_types.VOLUME,        perm: 0, label: "Volume tapwater" },
    { regAddr: 1850, type: rhm_reg_types.STATE3,        perm: 0, label: "3.5 pijps configuratie" },
    { regAddr: 1851, type: rhm_reg_types.TEMP,          perm: 0, label: "Koeling detectie temperatuur" },
    { regAddr: 1852, type: rhm_reg_types.TEMP,          perm: 0, label: "Verwarming detectie temperatuur" },
    { regAddr: 1853, type: rhm_reg_types.TEMP,          perm: 0, label: "Verlaagd verwarming setpoint" },
    { regAddr: 1854, type: rhm_reg_types.STATE8,        perm: 0, label: "Verlaagd setpoint in gebruik" },
    { regAddr: 1855, type: rhm_reg_types.STEPS,         perm: 0, label: "Minimale opening afsluiter predetectie" },
    { regAddr: 1856, type: rhm_reg_types.TIME_H,        perm: 0, label: "Detectie interval" },
    { regAddr: 1857, type: rhm_reg_types.TIME_H,        perm: 0, label: "Detectie timer" },
    { regAddr: 1858, type: rhm_reg_types.TIME_S,        perm: 0, label: "Predetectie tijd" },
    { regAddr: 1859, type: rhm_reg_types.TIME_S,        perm: 0, label: "Predetectie timer" },
    { regAddr: 1863, type: rhm_reg_types.STATE2,        perm: 0, label: "Boost functie" },
    { regAddr: 1864, type: rhm_reg_types.TIME_M,        perm: 0, label: "Boost detectie timer" },
    { regAddr: 1866, type: rhm_reg_types.STEPS,         perm: 0, label: "Maximale positie afsluiter tijdens Boost" },
  ]
};

module.exports = Constants_rhm;



// WEBPACK FOOTER //
// ./js/common/app-constants-rhm.js